/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

export const Container = styled.div<{ topOffset: number }>`
  display: flex;
  height: calc(100vh - ${props => props.topOffset}px);
  position: sticky;
  justify-content: flex-end;
`;
